import { Lightbulb, PenTool, Cog, Hammer } from "lucide-react";

const steps = [
  {
    icon: Lightbulb,
    number: "01",
    title: "Concept & Planning",
    description: "We work closely with you to understand your vision, space requirements, and budget. Our team develops comprehensive project plans tailored to your needs."
  },
  {
    icon: PenTool,
    number: "02",
    title: "Design & Engineering",
    description: "Our expert designers create detailed 3D models and technical drawings. We optimize every aspect for safety, functionality, and aesthetic appeal."
  },
  {
    icon: Cog,
    number: "03",
    title: "Precision Manufacturing",
    description: "Using state-of-the-art CNC equipment in our workshops, we manufacture all climbing structures to exact specifications with premium materials."
  },
  {
    icon: Hammer,
    number: "04",
    title: "Professional Installation",
    description: "Our experienced installation team handles complete on-site assembly, ensuring every detail meets our high standards and all safety certifications."
  }
];

const Process = () => {
  return (
    <section id="process" className="py-16 bg-gradient-hero text-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-64 h-64 border-4 border-white transform -rotate-12" />
        <div className="absolute bottom-10 right-10 w-96 h-96 border-4 border-white transform rotate-6" />
      </div>
      <div className="absolute inset-0 dot-pattern opacity-5" />
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-3xl mb-10">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-display mb-4">
            CLIMBING GYM BUILD PROCESS
          </h2>
          <p className="text-lg text-white/70">
            Professional climbing wall construction workflow from initial concept to final installation. 
            Complete turnkey bouldering gym development with expert design, manufacturing, and installation.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="relative group"
            >
              {/* Card */}
              <div className="bg-white/5 backdrop-blur-sm p-8 border border-white/10 hover:border-primary/50 transition-all duration-300">
                {/* Number Badge */}
                <div className="absolute -top-4 -left-4 w-16 h-16 bg-primary flex items-center justify-center text-white font-display text-2xl">
                  {step.number}
                </div>
                
                {/* Icon */}
                <div className="mb-6 mt-4">
                  <step.icon className="w-12 h-12 text-primary" />
                </div>
                
                {/* Content */}
                <h3 className="text-2xl font-display mb-4">
                  {step.title}
                </h3>
                <p className="text-white/70 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;